'use strict'

function initializeModal() {
  let $modalPlayer;
  $(document).ready(function () {
    // Open Modal
    $('.js-open-modal').on('click', openModal)

    // Close Modal
    $('.js-close-modal').on('click', closeModal)

    // Instantly open modals that are marked as instant
    $('.js-open-modal-instant').trigger('click')
  })

  function openModal (e) {
    e.preventDefault();
    const $this = $(this)
    const $modalIndicator = $this.data('modal')
    const $modal = $('#' + $modalIndicator)
    $modal.fadeIn(200, () => $modal.addClass('shown'))
  }

  function closeModal (e) {
    const $this = $(this)
    const el = $this.closest('.modal__wrapper')
    e.preventDefault();
    el.fadeOut(200, () => el.removeClass('shown'))
  }
}

export default initializeModal
